import axios from 'axios';
import ksoAccount from '@account/kso-acct-sdk';

const isEnvDevelopment = process.env.NODE_ENV === 'development';
axios.defaults.withCredentials = true;
axios.defaults.baseURL = isEnvDevelopment ? '/' : 'https://api-kos.wps.cn';
const service = axios.create({
  timeout: 5 * 60 * 1000,
});

service.interceptors.request.use(
  async (config) => {
    // kso_sid改造
    let full_url = config.baseURL + config.url; // 例如：https://api-kos.wps.cn/kps/admin/sys/list?name=aa
    full_url = full_url.replace(/\/\//, '').replace(/\?.*/, '');
    const uri = full_url.slice(full_url.indexOf('/')); // uri只要/kps/admin/sys/list
    try {
      const popToken = await ksoAccount.signPopToken(
        config.method.toUpperCase(),
        uri,
      );
      if (popToken && popToken !== 'empty') {
        config.headers['X-Pop-Token'] = popToken;
      }
    } catch (e) {
      // 签名失败时降级继续发请求，避免阻断业务
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  async (result) => {
    const { data } = result || {};
    return data;
  },
  (error) => {
    const status = error?.response?.status;
    if (status) {
      return Promise.reject(error?.response?.data);
    }
    return Promise.reject(error);
  },
);

export default service;
